import { render, staticRenderFns } from "./Footprint.vue?vue&type=template&id=42f80415&scoped=true&lang=pug"
import script from "./Footprint.vue?vue&type=script&lang=js"
export * from "./Footprint.vue?vue&type=script&lang=js"
import style0 from "./Footprint.vue?vue&type=style&index=0&id=42f80415&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f80415",
  null
  
)

export default component.exports